<template lang="pug" src="./login.pug"> </template>
<style lang="scss" src="./login.scss" scoped> </style>

<script>
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import validate from '@/mixins/validate';

export default {
    mixins: [validationMixin, validate],
    validations: {
        login: {
            required
        },
        password: {
            required,
            minLength: minLength(6)
        }
    },
    data: () => ({
        login: '',
        password: '',
        phone: '',
        requestProcessing: false
    }),
    methods: {
        submit(e) {
            e.preventDefault();

            if (this.$v.$invalid) {
                this.$v.$touch();
                return;
            }

            if (this.requestProcessing) return;

            this.requestProcessing = true;

            this.$store.dispatch('auth/login', {
                login: this.login,
                password: this.password,
                phone: this.phone
            }).then(() => {
                this.$nextTick(() => this.requestProcessing = false);
            });
        }
    }
};
</script>
